// extracted by mini-css-extract-plugin
module.exports = {"header":"Pre_header__Bkybn","pre":"Pre_pre__riR7B","normal":"Pre_normal__1QKJE","break":"Pre_break__2CTjm"};